import {
  Box,
  CircularProgress,
  Select,
  SvgIconProps,
  Typography,
} from '@material-ui/core';
import { Backup, Edit } from '@material-ui/icons';
import SendSharpIcon from '@material-ui/icons/SendSharp';
import UpdateIcon from '@material-ui/icons/Update';
import { ToggleButtonGroup } from '@material-ui/lab';
import palette from 'assets/palette';
import styled from 'styled-components';

export const TripsBox = styled(Box)`
  overflow: auto;
  padding: 2rem;
  min-height: calc(100vh - 200px);
`;

export const UpdateStateIcon = styled(UpdateIcon)<SvgIconProps>`
  &.MuiSvgIcon-root {
    cursor: pointer;
    font-size: 2rem;
    margin-left: 0.5rem;
    margin-bottom: 0.1rem;

    &:hover {
      color: ${palette.ACTION_DARK};
    }
  }
`;
export const FlexDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

export const SmallUploadFileIcon = styled(Backup)<SvgIconProps>`
  &.MuiSvgIcon-root {
    cursor: pointer;
    font-size: 2rem;
    margin-bottom: 0.1rem;
    z-index: 100;
    &:hover {
      color: ${palette.ACTION_DARK};
    }
  }
`;

export const SmallFileCounter = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffc703;
  z-index: 999;
  border-radius: 50%;
  padding: 0.2rem;
  margin: 0 -0.45rem 0.65rem;
  width: 0.8rem;
  height: 0.8rem;
  font-size: 0.7rem;
`;
export const CheckBoxLabel = styled.p`
  line-height: 8px;
`;
export const SmallEditIcon = styled(Edit)<SvgIconProps>`
  &.MuiSvgIcon-root {
    cursor: pointer;
    font-size: 2rem;
    margin-left: 0.3rem;
    margin-bottom: 0.1rem;

    &:hover {
      color: ${palette.ACTION_DARK};
    }
  }
`;

export const SendToVerifyIcon = styled(SendSharpIcon)<SvgIconProps>`
  &.MuiSvgIcon-root {
    cursor: pointer;
    font-size: 2rem;
    margin-left: 0.7rem;
    margin-bottom: 0.1rem;

    &:hover {
      color: ${palette.ACTION_DARK};
    }
  }
`;

export const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const FilterBar = styled(Box)`
  &.MuiBox-root {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
    margin: 0.5rem 0;
  }
`;

export const FilterActions = styled(Box)`
  &.MuiBox-root {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-left: auto;
  }
  & .MuiButton-root {
    height: 40px;
  }
`;

export const FilterNote = styled(Typography)`
  &.MuiTypography-root {
    font-size: 0.875rem;
    color: ${palette.ACCENT_DARKER};
  }
`;

export const SegmentedControl = styled(ToggleButtonGroup)`
  &.MuiToggleButtonGroup-root {
    flex-wrap: wrap;
  }
  & .MuiToggleButton-root {
    height: 40px;
    text-transform: none;
    color: ${palette.ACCENT_DARKEST};
  }
  & .MuiToggleButton-root.Mui-selected {
    background-color: ${palette.ACTION_LIGHTER};
    color: rgb(0 0 0);
  }
  & .MuiToggleButton-root.Mui-selected:hover {
    background-color: ${palette.ACTION};
  }
`;

export const NeedsCount = styled.span`
  margin-left: 6px;
  min-width: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background-color: ${palette.ACCENT_DARKEST};
  color: ${palette.ACCENT_WHITE};
  font-size: 0.75rem;
  line-height: 20px;
`;

export const StatusSelect = styled(Select)`
  &.MuiInputBase-root {
    min-width: 220px;
  }
`;
